import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'wm-instructions-page',
  templateUrl: './instructions-page.component.html',
  styleUrl: './instructions-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InstructionsPageComponent {}
